export function message(
  text: unknown,
  fallback: string,
  variables?: Record<string, string | number>
): string {
  let txt: string = fallback;

  if (typeof text === 'string') {
    txt = text;
  }

  if (typeof variables === 'object' && variables !== null) {
    Object.keys(variables).forEach((variable) => {
      txt = txt.replace(
        new RegExp(`{{${variable}}}`, 'g'),
        variables[variable].toString()
      );
    });
  }

  return txt;
}
